import { datadogRum } from '@datadog/browser-rum';
import { FEATURE_FLAGS_OVERRIDE } from 'core/constants';
import { isDatadogActive } from 'core/services/datadog';

/** Keys must match the flag name configured in Datadog exactly, so RUM evaluations line up. */
export type FeatureFlagName = 'test-feature-flag';

const DEFAULT_FEATURE_FLAGS: Record<FeatureFlagName, boolean> = {
  'test-feature-flag': false
};

// AGENT NOTE: v1 has no per-user/per-builder targeting — it's a static default map plus an env
// override. Future targeting seam: `builder_id` (core/services/HomeSlice.tsx), user identity
// (core/services/UserSlice.ts), and Firestore/Remote Config via `db`/`firebaseApp`
// (core/hooks/useFirebase.ts). Do not wire targeting here without also updating the RUM
// reporting call below to attach the resolved identity.
export function getFeatureFlag(name: FeatureFlagName): boolean {
  return FEATURE_FLAGS_OVERRIDE[name] ?? DEFAULT_FEATURE_FLAGS[name] ?? false;
}

/** Reports an evaluation to Datadog RUM so it correlates with sessions/errors. No-op when inactive. */
export function reportFeatureFlag(name: FeatureFlagName, value: boolean): void {
  if (!isDatadogActive()) return;

  try {
    datadogRum.addFeatureFlagEvaluation(name, value);
  } catch (error) {
    console.warn(
      'Datadog feature-flag evaluation report failed; continuing.',
      error
    );
  }
}
